import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './TitlePage.css';


const TitlePage = ({ getString, onAcceptDisclaimer }) => (
  <div className="title-content-block header-border">
    <div className="row justify-content-center">
      <div className="col-4">
        <img className="title-logo" alt="title" src={`${process.env.PUBLIC_URL}/images/HCA-Connect.svg`} />
        <p>
          {getString('license-gateway-1', 'general')}&nbsp;
          <a href={getString('license-url')} target="_blank">
            {getString('license-gateway-2', 'general')}
          </a>
          &nbsp;{getString('license-gateway-3', 'general')}
        </p>
        <p id="disclaimer">
          {getString('disclaimer', 'general')}
        </p>
        <div className="btn-block">
          <button type="button" onClick={onAcceptDisclaimer} className="blue-btn">
            <div className="arrow-right" />
            {getString('accept', 'general')}
          </button>
        </div>
      </div>
    </div>
  </div>
);

TitlePage.propTypes = {
  onAcceptDisclaimer: PropTypes.func.isRequired,
  getString: PropTypes.func.isRequired
};

export default connect(
  state => ({
    getString: state.strings.getString
  }),
)(TitlePage);
